export default __webpack_public_path__ + "static/media/visitfulllogo.3e2938fb.png";